import type { FormModel } from '@ikegps/core-shared';
import { Services } from '../services';
import { FormEditState } from '../state/form.edit.state';

export class FormStore {
	edits: { [key: string]: FormEditState } = {};
	edit(form: FormModel): FormEditState {
		let currentEdit = this.edits[form.version];
		if (currentEdit == null) {
			currentEdit = this.edits[form.version] = new FormEditState(form);
		}

		return currentEdit;
	}

	clearEdit(form: FormModel) {
		delete this.edits[form.version];
	}

	get(version: string): FormModel | null {
		const rest = Services.Department.rest;
		return rest.form('version', version).value;
	}

	fetch(version: string): Promise<FormModel> {
		const rest = Services.Department.rest;
		return rest.form('version', version).fetch();
	}

	exists(version: string): boolean {
		const rest = Services.Department.rest;
		const fetchable = rest.form('version', version);
		return fetchable.isFetching || fetchable.value != null;
	}
}
